export enum CMSContentType {
  headerOne,
  headerTwo,
  list,
  imageList,
  richText,
  twoColumns,
  gallery,
  map,

  transfers,
  playerList,
  details
}



// WEBPACK FOOTER //
// ./src/api/club-cms/CMSType.ts